import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { GTMApiStatus, GTMEvents } from 'src/app/model/google-tag-manager/api-status';
@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  billingPath: string;

  constructor(
    private router: Router,
    public googleAnalyticsService: GoogleAnalyticsService,
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.preInitSettingsService.settings.subscribe(settings => {
      if (settings.middleWare) {
        this.billingPath = settings.middleWare.billingPath;
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      tap({
        error: err => {
          if (err instanceof HttpErrorResponse) {
            if (request.url.includes(`${this.billingPath}paymentprofile`)) {
              this.googleAnalyticsService.emitGTMEvent({
                event: GTMEvents.UpdatePayment,
                event_status: GTMApiStatus.Failed
              });
            }
            else if (request.url.includes(`${this.billingPath}payment`)) {
              this.googleAnalyticsService.emitGTMEvent({
                event: GTMEvents.MakePayment,
                event_status: GTMApiStatus.Failed
              });
            }
          }
        }
      })
    );
  }
}
